import type { JSX } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from './lib/session';
import { ThemeProvider } from './themes/ThemeProvider';
import { BetslipProvider } from './lib/betslip';
import { Shell } from './components/Shell';
import { LoginPage, RegisterPage, VerifyPage } from './pages/Auth';
import { LobbyPage } from './pages/Lobby';
import { WalletPage } from './pages/Wallet';
import { HomePage } from './pages/Home';
import { SportsPage } from './pages/Sports';
import { DepositPage } from './pages/Deposit';
import { WithdrawPage } from './pages/Withdraw';
import { LotteryPage } from './pages/Lottery';
import { LoDePage } from './pages/LoDe';
import { DemoPage } from './pages/Demo';
import { ThemeGalleryPage } from './pages/ThemeGallery';
import { PromotionsPage } from './pages/Promotions';
import { BetsPage } from './pages/Bets';
import { AccountPage } from './pages/Account';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Man hinh nay doc nhieu du lieu doi lien tuc; thu lai vo han khi may chu
      // tu choi vi nghiep vu chi lam nguoi dung doi lau hon ma khong duoc gi.
      retry: (failureCount, error) => {
        const status = (error as { status?: number }).status;
        if (status !== undefined && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: true,
    },
  },
});

export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider>
          <SessionProvider>
            <BetslipProvider>
              <Routes>
                <Route path="/dang-nhap" element={<LoginPage />} />
                <Route path="/dang-ky" element={<RegisterPage />} />
                <Route path="/xac-minh" element={<VerifyPage />} />
                <Route path="/demo" element={<DemoPage />} />
                <Route path="/giao-dien" element={<ThemeGalleryPage />} />

                <Route element={<Shell />}>
                  <Route index element={<HomePage />} />
                  <Route path="/the-thao" element={<SportsPage />} />
                  <Route path="/song-bai" element={<LobbyPage fixedCategory="LIVE_CASINO" />} />
                  <Route path="/quay-hu" element={<LobbyPage fixedCategory="SLOTS" />} />
                  <Route path="/tro-choi" element={<LobbyPage />} />
                  <Route path="/vi" element={<WalletPage />} />
                  <Route path="/nap-tien" element={<DepositPage />} />
                  <Route path="/rut-tien" element={<WithdrawPage />} />
                  <Route path="/xo-so" element={<LotteryPage />} />
                  <Route path="/lo-de" element={<LoDePage />} />
                  <Route path="/khuyen-mai" element={<PromotionsPage />} />
                  <Route path="/cuoc-cua-toi" element={<BetsPage />} />
                  <Route path="/tai-khoan" element={<AccountPage />} />
                  <Route path="/tai-khoan/dinh-danh" element={<AccountPage section="dinh-danh" />} />
                  <Route path="/tai-khoan/han-muc" element={<AccountPage section="han-muc" />} />
                  <Route path="/tai-khoan/hoat-dong" element={<AccountPage section="hoat-dong" />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
              </Routes>
            </BetslipProvider>
          </SessionProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
